<button
  mat-flat-button
  *ngIf="!mobile"
  class="btn-menu"
  [matMenuTriggerFor]="menuSelect"
  (click)="toggleMenu()"
>
  <i class="icon-font icon-menu-1"></i>
</button>
<mat-menu #menuSelect xPosition="after" [class]="'main-menu'">
  <ng-container *ngFor="let item of mainMenu">
    <button
      *ngIf="!item?.hidden"
      [ngClass]="item.itemCssClass"
      [routerLink]="item.router"
      [disabled]="disableMenuClick"
      class="menu-item">
      <span class="menu-item-text" > {{ item.name | translate }}</span>
      <span class="item-quantity" *ngIf="item?.quantity">{{ item.quantity }}</span>
    </button>
  </ng-container>
  <div [ngClass]="{ 'menu-item': true, 'log-out': true, 'business-log-out': isBusinessAdmin() }"  (click)="logout()">
     <span class="log-out-text">{{ 'exit' | translate }}</span>
  </div>
  <div class="person-info" *ngIf="getSettingValue('responsiblePersonName')">
    <div class="menu-item main-info">
        <div class="name">{{ getSettingValue('responsiblePersonFirstName') }} {{ getSettingValue('responsiblePersonLastName') }}</div>
        <div class="responsible-manager-message">{{'responsible-manager-message' | translate }}  </div>
    </div>
    <div class="menu-item link" *ngIf="getSettingValue('responsiblePersonPhone')">
      <a class="link-item"  [attr.href]="'tel:' + getSettingValue('responsiblePersonPhone')">
        {{ getSettingValue('responsiblePersonPhone') }}
      </a>
      <i class="icon icon-copy-clipboard cursor-pointer"
         [cdkCopyToClipboard]="getSettingValue('responsiblePersonPhone')">
      </i>
    </div>
    <div class="menu-item link" *ngIf="getSettingValue('responsiblePersonEmail')">
      <a class="link-item" [attr.href]="'mailto:' + getSettingValue('responsiblePersonEmail')">
        {{ getSettingValue('responsiblePersonEmail') }}
      </a>
      <i class="icon icon-copy-clipboard cursor-pointer"
         [cdkCopyToClipboard]="getSettingValue('responsiblePersonEmail')">
      </i>
    </div>
  </div>
</mat-menu>

<i
  *ngIf="mobile"
  class="icon-font icon-menu icon-menu-mobile"
  (click)="toggleMobileMenu()"
></i>
<app-more
  *ngIf="openMobileMenu"
  [mobile]="mobile"
  [mainMenu]="mainMenu"
  (navigateFormMenu)="navigateFormMenu($event)"
  (isCloseMenu)="closeMenuMore()"
  [notificationCounter]="notificationCounter"
></app-more>
